import { getAdminDataSource, getAdminDataSourceInfo } from "data/admin/dataSource";

function clone(value) {
  return JSON.parse(JSON.stringify(value));
}

function createId(prefix) {
  return `${prefix}-${Math.random().toString(16).slice(2, 8)}-${Date.now().toString(16)}`;
}

export function createAdminRepository(config) {
  const {
    collectionName,
    idPrefix,
    getId = (item) => item.id,
    normalize = (item) => item,
    supportsSoftDelete = true,
  } = config;

  const readItems = () => {
    const items = getAdminDataSource().listCollection(collectionName);
    return Array.isArray(items) ? items : [];
  };

  const writeItems = (items) => {
    getAdminDataSource().writeCollection(collectionName, items);
  };

  const decorate = (item) => {
    const normalized = normalize(clone(item));
    const resolvedId = getId(normalized) || normalized.id;

    return resolvedId && normalized.id !== resolvedId
      ? { ...normalized, id: resolvedId }
      : normalized;
  };

  const list = (params = {}) => {
    let items = readItems().map(decorate);

    if (!params.includeDeleted) {
      items = items.filter((item) => !item.deletedAt);
    }

    if (typeof params.filter === "function") {
      items = items.filter(params.filter);
    }

    return items;
  };

  const getById = (id, params = {}) => list(params).find((item) => item.id === id || getId(item) === id) || null;

  const saveAll = (items) => writeItems(items.map((item) => decorate(item)));

  return {
    list,
    getById,
    create(input) {
      const current = readItems();
      const now = new Date().toISOString();
      const nextItem = decorate({
        ...input,
        id: getId(input) || input.id || createId(idPrefix),
        createdAt: input.createdAt || now,
        updatedAt: now,
        deletedAt: null,
      });

      if (current.some((item) => decorate(item).id === nextItem.id)) {
        throw new Error("Aynı kimliğe sahip kayıt zaten mevcut");
      }

      writeItems([nextItem, ...current]);
      return nextItem;
    },

    update(id, patch) {
      const current = readItems();
      let updatedItem = null;

      const next = current.map((item) => {
        const normalized = decorate(item);
        if (normalized.id !== id && getId(normalized) !== id) return normalized;

        updatedItem = decorate({
          ...normalized,
          ...patch,
          id: normalized.id,
          updatedAt: new Date().toISOString(),
        });

        return updatedItem;
      });

      writeItems(next);
      return updatedItem;
    },

    remove(id) {
      if (!supportsSoftDelete) {
        saveAll(readItems().filter((item) => decorate(item).id !== id));
        return;
      }

      return this.update(id, { deletedAt: new Date().toISOString() });
    },

    restore(id) {
      if (!supportsSoftDelete) return null;
      return this.update(id, { deletedAt: null });
    },

    getMeta() {
      return {
        collectionName,
        dataSource: getAdminDataSourceInfo(),
      };
    },
  };
}